import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { constants } from 'src/app/constants';

@Component({
  selector: 'login',
  template: ''
})
export class LoginComponent implements OnInit {
  private loaderDialog: any;
  private returnUrl: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private http: HttpClient
  ) { }

  public ngOnInit() {
    // subscribe to router event
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      //let accessToken = 'slQPtv5QuMulCfVC2zQojw'; // remove this line and uncomment below line while doing any load
      let accessToken = params['access_token'];
      // state where user went to login page
      this.returnUrl = this.activatedRoute.snapshot.queryParams['state'].split("?", 1) || '/';
      if (this.activatedRoute.snapshot.queryParams['state'].split("?")[1]) {
        localStorage.setItem('redirection_params', this.activatedRoute.snapshot.queryParams['state'].split("?")[1]);
      }
      if (!accessToken) {
        constants.access_token = "";
        // redirect to CLP
        let redirectUri: string = location.protocol +
          '//' +
          location.hostname +
          (location.port ? ':' + location.port : '') +
          location.pathname +
          '#/login?state=' +
          this.returnUrl;

        redirectUri = encodeURIComponent(redirectUri);
        let env = constants.APP_CONFIG[location.host];
        let sapId = constants.SAP_ID[env.toUpperCase()];
        let clp = constants.CLP_URL.url;

        // incase of production this should be www.
        if (env === 'prd') {
          env = 'www';
        }
        clp = clp.replace(/{ENV}/, env.toLowerCase());
        const clpURL = clp.replace(/{SAPID}/, sapId);
        window.location.href = clpURL + redirectUri;
      } else {
        constants.access_token = accessToken;
        const redirectionParams = localStorage.getItem('redirection_params');
        var thisReturnURL = this.returnUrl[0];
        if (redirectionParams) {
          thisReturnURL += '?'+redirectionParams;
        }
        //remove the local storage item, so that it does not gives any conflict on the next load.
        localStorage.removeItem('redirection_params');

        // redirct to search or page where user come from
        this.router.navigateByUrl(thisReturnURL);
        // replace back history to home
        this.location.replaceState('/');
      }
    });
  }
}
